import { useParams } from "react-router-dom";
import { useGetScheduleById } from "../../hooks";
import { ScheduleKeyMetricsRow } from "./components/ScheduleKeyMetrixRow";
import { ScheduleKeyStatsCard } from "./components/ScheduleKeyStatsCard";
import { ScheduleProfileCard } from "./components/ScheduleProfileCard";
import { ScheduleQuickActionsSidebar } from "./components/ScheduleQuickActionSidebar";
import { ScheduleTabs } from "./components/ScheduleTabs";

const ScheduleDetail = () => {
  const { id } = useParams<{ id: string }>();
  const { data: scheduleData } = useGetScheduleById(id);

  return (
    <div className="p-3">
      <div className="max-w-[1400px] mx-auto space-y-6">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          <div className="lg:col-span-3 space-y-6">
            <ScheduleProfileCard data={scheduleData} />
            <ScheduleKeyMetricsRow data={scheduleData} />
          </div>
          <div className="space-y-6">
            <ScheduleKeyStatsCard data={scheduleData} />
            <ScheduleQuickActionsSidebar data={scheduleData} />
          </div>
        </div>
        <div className="w-full">
          <ScheduleTabs data={scheduleData} />
        </div>
      </div>
    </div>
  );
};

export default ScheduleDetail;
